import { useFieldArray, useWatch } from "react-hook-form";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import PlusIcon from "../../../components/Icons/PlusIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import BudgetExpenseHead from "./BudgetExpenseHead";

const BudgetRequestSection = ({
    control,
    register,
    sectionIndex,
    removeSection,
    siteId,
    errors,
    setValue,
    usedRequestTypes,
    globalRequestType,
    activeFinancialYear,
    isEditMode,
    expenseHeadType = []
}) => {
    const { fields, append, remove, replace } = useFieldArray({
        control,
        name: `sections.${sectionIndex}.expenseHeads`,
    });

    const requestType = useWatch({
        control,
        name: `sections.${sectionIndex}.requestType`,
    });

    const expenseHeads = useWatch({
        control,
        name: `sections.${sectionIndex}.expenseHeads`,
    });

    const handleRequestTypeChange = (e) => {
        setValue(`sections.${sectionIndex}.requestType`, e.target.value);
        replace([{ expenseHeadId: "", items: [] }]);
    };



    return (
        <div className="card mb-3 border-primary">
            <div className="card-body">
                <div className="row">
                    <div className="col-6">
                        <div className="form-group mb-3">
                            <label className="form-label fw-bold">Request Type</label>
                            <select
                                className="form-select form-control"
                                {...register(`sections.${sectionIndex}.requestType`, {
                                    required: "Request Type is required",
                                    onChange: handleRequestTypeChange
                                })}
                                disabled={siteId === ""}
                            >
                                <option value="">Select Request Type</option>
                                {expenseHeadType?.map((type) => (
                                    <option key={type.id} value={type.name} disabled={!type?.isThere
                                        || usedRequestTypes.includes(type.name) &&
                                        requestType !== type.name}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                            <ErrorMessage
                                message={errors?.sections?.[sectionIndex]?.requestType?.message}
                            />
                        </div>
                    </div>
                </div>

                <div className="ps-3 border-start border-3 border-primary">
                    {fields.map((head, headIndex) => (
                        <BudgetExpenseHead
                            key={head.id}
                            control={control}
                            register={register}
                            sectionIndex={sectionIndex}
                            headIndex={headIndex}
                            removeHead={remove}
                            errors={errors}
                            setValue={setValue}
                            usedExpenseHeads={expenseHeads?.map((h) => h.expenseHeadId) || []}
                            globalRequestType={globalRequestType}
                            requestType={requestType}
                            siteId={siteId}
                            activeFinancialYear={activeFinancialYear}
                            isEditMode={isEditMode}
                        />
                    ))}

                    <div className="mb-3">
                        <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => append({ expenseHeadId: "", items: [] })}
                            disabled={!requestType}
                        >
                            <PlusIcon /> Add Expense Head
                        </button>
                    </div>
                </div>

                <div className="text-end mt-2">
                    <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => removeSection(sectionIndex)}
                    >
                        <DeleteIcon /> Remove Section
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BudgetRequestSection;
